<div class="flex flex-col w-full bg-white">

    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-3 px-4 md:px-8 border-b">

        <!-- Title -->
        <div class="flex flex-row items-start md:items-center">
            <div class="flex items-center">
                <arrow-back></arrow-back>
                <mat-icon class="icon-size-14 mx-1 md:mx-4 text-gray-400" [svgIcon]="'account_balance'"></mat-icon>
            </div>
            <div>
                <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">Agregar Bien Cultural</div>
                <div class="ml-0.5 font-medium text-secondary mt-1">Sección/{{titulo}}</div>
            </div>
        </div>

    </div>

    <div class="w-full">
      <div class="w-full flex justify-center">
        <form [formGroup]="formGroup" 
            class="flex flex-col justify-center w-full md:w-4/12 p-6">
            <ng-template matStepLabel></ng-template>
            <mat-form-field class="fuse-mat-dense">
              <mat-label>Nombre</mat-label>
                <input matInput id="nombre" [formControlName]="'nombre'" placeholder="Nombre del Bien Cultural" required>
            </mat-form-field>

            <div class="font-medium">Tipo de Bien*</div>
            <mat-radio-group aria-label="Select an option" class="mb-2" [formControlName]="'tipoDeBien'" (change)="onTipoDeBienChange($event.value)">
                <mat-radio-button [value]="tipologiaBienMueble" [disabled]="this.bienInmueble && this.seccion === this.typology_id_bienes_inmuebles">Mueble</mat-radio-button>
                <mat-radio-button [value]="tipologiaBienInmueble" [disabled]="this.codigoColeccionista">Inmueble</mat-radio-button>
            </mat-radio-group>

            <mat-form-field class="fuse-mat-dense">
              <mat-label>Tipo de Propiedad</mat-label>
              <mat-select formControlName="tipoPropiedad" id="tipoPropiedad">
                    @for (tipo of tipoPropiedad; track tipo) {
                        <mat-option [value]="tipo.tipologiaId">{{tipo.descripcion}}</mat-option>
                    }
                </mat-select>
            </mat-form-field> 

            @if(!bienInmueble){
              <mat-form-field class="fuse-mat-dense">
              <mat-label>Poseedor</mat-label>
              <input type="text"
                     matInput
                     [formControl]="poseedorCtrl"
                     [matAutocomplete]="auto"
                     (input)="filter$.next($event.target.value)" 
                      [readonly]="codigoColeccionista"
                     />
            
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  <mat-option *ngFor="let c of filtroColeccionitas$ | async" [value]="c">
                    ({{c.coleccionista.codigoColeccionista}}) - {{ c.coleccionista.nombre }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              @if(this.seccion != SECCION_PREHISPANICA){
                <mat-checkbox 
                  class="mb-2"
                  [checked]="true"
                  (change)="isOwner($event.checked)"
                >
                  Registrar como propietario
                </mat-checkbox>
              }


              <mat-form-field class="fuse-mat-dense">
                <mat-label>Propietario</mat-label>
                <input matInput [formControlName]="'propietarioNombre'" 
                      name="propietarioNombre"
                      id="propietarioNombre" type="text" [readonly]="readonlyPropietario"/>
              </mat-form-field>    
                
              <mat-form-field class="fuse-mat-dense">
                <mat-label>Colección</mat-label>
                <input matInput [value]="descripcionColeccion" readonly />
              </mat-form-field>  
            }  

          @if(bienInmueble){
            <mat-form-field class="fuse-mat-dense flex-1">
                <mat-label>Departamento</mat-label>
                <input
                  matInput
                  formControlName="departamento"
                  [matAutocomplete]="auto"
                  (input)="filterDepartamento$.next($event.target.value)"
                />

                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnDepartamento"
                (optionSelected)="getMunicipios1($event.option.value)">
                  <mat-option *ngFor="let d of departamentos$ | async" [value]="d">
                    {{ d.descripcion }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>


          <mat-form-field class="fuse-mat-dense flex-1">
              <mat-label>Municipio</mat-label>
              <input type="text" #municipioInput
                      matInput
                      formControlName="municipio" id="municipio"
                      name="municipio"
                      id="municipio"
                      [matAutocomplete]="autoMunicipio"
                      (input)="filterMunicipios$.next($event.target.value)"
                      />

              <mat-autocomplete
                  #autoMunicipio="matAutocomplete" 
                  [displayWith]="displayFnMunicipio">
                   <mat-option *ngFor="let m of municipios$ | async" [value]="m">
                    {{ m.descripcion }}
                    </mat-option>
              </mat-autocomplete>
          </mat-form-field>

          <div class="font-medium">Titular*</div>
            <mat-radio-group aria-label="Select an option" 
                class="mb-2" 
                [formControlName]="'titular'" 
                (change)="onTitularChange($event.value)">
                @for(t of titular; track t){
                    <mat-radio-button [value]="t.tipologiaId">{{t.descripcion}}</mat-radio-button>
                }
            </mat-radio-group> 

            <mat-form-field class="fuse-mat-dense">
              <mat-label>Nombre del Propietario</mat-label>
              <input matInput [formControlName]="'propietarioNombre'" name="propietarioNombre"
                      id="propietarioNombre" type="text"
                      [readonly]="readonlyPropietario"/>
            </mat-form-field>  

            <mat-form-field class="fuse-mat-dense"  *ngIf="formGroup.get('titular')?.value === ID_POSEEDOR">
              <mat-label>Nombre del Poseedor</mat-label>
              <input matInput [formControlName]="'nombrePoseedor'" name="nombrePoseedor"
                      id="nombrePoseedor" type="text" [required]="formGroup.get('titular')?.value != ID_PROPIETARIO"/>
            </mat-form-field>  

            <mat-form-field class="fuse-mat-dense">
              <mat-label>Coleccion</mat-label>
              <mat-select formControlName="coleccion" id="coleccion">
                    @for (c of colecciones; track c) {
                        <mat-option [value]="c">{{c.descripcion}}</mat-option>
                    }
                </mat-select>
            </mat-form-field> 

            <mat-form-field class="fuse-mat-dense">
              <mat-label>Finca</mat-label>
              <input matInput  [formControlName]="'finca'" />
            </mat-form-field>  

            <mat-form-field class="fuse-mat-dense">
              <mat-label>Folio</mat-label>
              <input matInput  [formControlName]="'folio'" />
            </mat-form-field>  

            <mat-form-field class="fuse-mat-dense">
              <mat-label>libro</mat-label>
              <input matInput  [formControlName]="'libro'" />
            </mat-form-field> 
           }

              
            <div class="mt-6">
              <button mat-fab color="seccondary" class="w-full rounded-md font-bold h-11" (click)="guardarBienCultural()" [disabled]="!this.formGroup.valid">Guardar y Continuar</button>
            </div>
          </form>
      </div>
    </div>
</div>